import React, { type FC, type PropsWithChildren, type ReactNode } from 'react'
import cn from 'classnames'
import styles from './OnboardingBannerLayout.module.scss'

interface OnboardingBannerProps {
  title: string
  subtitle: ReactNode
  footer?: ReactNode
  onDismiss?: () => void
}

export const OnboardingBannerLayout: FC<PropsWithChildren<OnboardingBannerProps>> = ({ title, subtitle, footer, children, onDismiss }) => {
  return (
    <div className={cn(styles.container, 'position-relative zocks-border-primary-light p-4')}>
      <svg
        aria-hidden='true'
        transform='translate(70, -5)'
        className={styles.waveBg}
        xmlns='http://www.w3.org/2000/svg'
        width='729'
        height='102'
        viewBox='0 0 729 102'
        fill='none'
      >
        <path
          d='M742.588 88.6387L6.15488 179.36L-0.00026078 129.396L511.333 6.75839C511.333 6.75839 537.142 -0.162243 554.735 0.00279771C571.054 0.155901 595.379 6.26751 595.379 6.26751L736.433 38.6743L742.588 88.6387Z'
          fill='#F9F6FF'
        />
      </svg>
      <svg
        aria-hidden='true'
        transform='translate(30, 10)'
        className={styles.waveBg}
        xmlns='http://www.w3.org/2000/svg'
        width='728'
        height='87'
        viewBox='0 0 728 87'
        fill='none'
      >
        <path
          d='M743.18 83.7178L6.74667 174.439L-3.21523e-05 119.673L513.802 6.95735C513.802 6.95735 535.823 -0.370963 553.442 0.0148802C569.787 0.372811 593.905 4.81123 593.905 4.81123L736.433 28.9514L743.18 83.7178Z'
          fill='#EBE5FC'
        />
      </svg>

      <div className='d-flex gap-4 position-relative'>
        <div className='flex-fill d-flex flex-column gap-2'>
          <span className='h6'>{title}</span>
          <span className={cn(styles.subtitle, 'fw-light zocks-text-gray-600 sm')}>{subtitle}</span>
          {footer}
        </div>
        <div className='d-flex flex-column gap-3 align-items-end justify-content-between flex-shrink-0'>
          <button onClick={onDismiss} className='btn btn-close icon-tiny' aria-label='Dismiss' />
          <div className='d-flex gap-2 align-items-center'>{children}</div>
        </div>
      </div>
    </div>
  )
}
